import { useTranslate, useUpdate } from "ra-core";

import type { Tag } from "../types";
import { TagDialog } from "./TagDialog";

type TagEditModalProps = {
  tag: Tag;
  open: boolean;
  onClose(): void;
  onSuccess?(tag: Tag): Promise<void>;
};

export function TagEditModal({
  tag,
  open,
  onClose,
  onSuccess,
}: TagEditModalProps) {
  const [update] = useUpdate<Tag>();
  const translate = useTranslate();

  const handleEditTag = async (data: Pick<Tag, "name" | "color">) => {
    // See TagCreateModal: without returnPromise the failure never reaches
    // TagDialog, which then closes as though the rename had worked.
    await update(
      "tags",
      { id: tag.id, data, previousData: tag },
      {
        returnPromise: true,
        onSuccess: async (tag) => {
          await onSuccess?.(tag);
        },
      },
    );
  };

  return (
    <TagDialog
      open={open}
      title={translate("resources.tags.dialog.edit_title")}
      onClose={onClose}
      onSubmit={handleEditTag}
      tag={tag}
    />
  );
}
